module.exports = __webpack_public_path__ + "img/03.adee2eea.png";